import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, API_BASE } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { formatMoney, formatDate } from "@/lib/format";

const CFG = {
  sales: { title: "Satış Faturaları", endpoint: "/sales-invoices", newRoute: "/satis-faturalari/yeni", detailRoute: "/satis-faturalari" },
  purchase: { title: "Alış Faturaları", endpoint: "/purchase-invoices", newRoute: "/alis-faturalari/yeni", detailRoute: "/alis-faturalari" },
};

export default function InvoicesList({ kind }) {
  const cfg = CFG[kind];
  const [items, setItems] = useState([]);
  const nav = useNavigate();
  const load = async () => setItems((await api.get(cfg.endpoint)).data);
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [kind]);
  return (
    <div className="space-y-6" data-testid={`${kind}-invoices-page`}>
      <div className="flex items-center justify-between">
        <div><div className="text-xs uppercase tracking-widest text-zinc-500">Fatura</div><h1 className="text-3xl mt-1">{cfg.title}</h1></div>
        <Button data-testid={`new-${kind}-invoice-button`} onClick={()=>nav(cfg.newRoute)} className="bg-zinc-900 hover:bg-zinc-800"><Plus size={16} className="mr-1"/>Yeni Fatura</Button>
      </div>
      <div className="bg-white rounded-md border border-zinc-200 overflow-hidden">
        <table className="acc">
          <thead><tr><th>No</th><th>Tarih</th><th>Cari</th><th className="num">Ara Toplam</th><th className="num">KDV</th><th className="num">Toplam</th></tr></thead>
          <tbody>
            {items.length===0 && <tr><td colSpan={6} className="text-center text-zinc-500 py-8">Fatura yok</td></tr>}
            {items.map(inv => (
              <tr key={inv.id} data-testid={`${kind}-invoice-row-${inv.id}`} onClick={()=>nav(`${cfg.detailRoute}/${inv.id}`)}>
                <td className="font-medium">{inv.invoice_number}</td>
                <td className="text-zinc-600">{formatDate(inv.date)}</td>
                <td>{inv.entity_name}</td>
                <td className="num">{formatMoney(inv.subtotal, inv.currency)}</td>
                <td className="num">{formatMoney(inv.vat_total, inv.currency)}</td>
                <td className="num font-medium">{formatMoney(inv.total, inv.currency)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
